import { reactive } from 'vue';

/**
 * 全局运行时配置
 * 采用静态脚本注入方案 (Static Script Injection)
 * 确保在项目启动时配置已在 window.runtimeConfig 中就绪
 */
const config = reactive({
  companyName: '',
  apiBaseUrl: '',
  projectName: '',
  homePath: '',
  homeName: '',
  homeId: '',
  clientId: '',
  clientSecret: '',
  authBase: '',
  authApiBase: '',
  redirectUri: '',
  authType: false,
  apmURL: '',
  theme: ''
});

/**
 * 应用配置项
 * @param {Object} cfg 
 */
export function applyConfig(cfg) {
  if (!cfg) return;
  Object.keys(config).forEach(key => {
    if (cfg.hasOwnProperty(key)) {
      config[key] = cfg[key];
    }
  });
}

/**
 * 初始化加载
 * 由于采用了静态脚本注入，配置在 window.runtimeConfig 中直接可用
 */
export async function loadConfig() {
  if (window.runtimeConfig) {
    applyConfig(window.runtimeConfig);
  } else {
    console.warn('window.runtimeConfig is not defined. Please check config.js injection.');
  }
  return config;
}

// 立即尝试应用初始配置（同步）
if (window.runtimeConfig) {
  applyConfig(window.runtimeConfig);
}

export default config;
